export default __webpack_public_path__ + "static/media/12-22.209226d3.jpeg";